export default __webpack_public_path__ + "static/media/demo-img.1a6b280d.png";